module.exports = __webpack_public_path__ + "img/icons-filter.6ab35b69.svg";